import React, { ReactElement } from 'react';
import { Layout, LayoutProps } from './models';

export const PublicLayout: Layout = ({
  children,
}: LayoutProps): ReactElement => <div>{children}</div>;
